'use client'
// storage.js
export const storage = {
  // Exchange rates with timestamp
  getRates: () => {
    if (typeof window === 'undefined') return
    const data = localStorage.getItem('exchangeRates')
    if (!data) return null

    const { rates, timestamp } = JSON.parse(data)

    // Cache is valid for 1 hour (3600000 ms)
    if (Date.now() - timestamp < 3600000) {
      return rates
    }
    return null
  },

  setRates: (rates: any) => {
    if (typeof window === 'undefined') return
    localStorage.setItem(
      'exchangeRates',
      JSON.stringify({
        rates,
        timestamp: Date.now(),
      }),
    )
  },

  // User preferences
  getUserPrefs: () => {
    const defaultPrefs = {
      currency: 'USD',
      country: 'US',
      locale: 'en-US',
      currency_symbol: '$',
    }

    if (typeof window === 'undefined') {
      return defaultPrefs // Return default on server-side for SSR compatibility
    }

    const prefs = localStorage.getItem('userPreferences')
    if (prefs) {
      try {
        return JSON.parse(prefs)
      } catch (error) {
        console.warn('Error parsing user preferences:', error)
        return defaultPrefs
      }
    }

    return defaultPrefs // Return default when no preferences stored
  },

  // Check if user has explicitly saved preferences (returns true/false)
  hasStoredPrefs: () => {
    if (typeof window === 'undefined') return false
    return localStorage.getItem('userPreferences') !== null
  },

  setUserPrefs: (prefs: any) => {
    if (typeof window === 'undefined') return

    // Get existing preferences synchronously to avoid circular calls
    const existingPrefs = (() => {
      try {
        const stored = localStorage.getItem('userPreferences')
        return stored ? JSON.parse(stored) : {}
      } catch (error) {
        console.warn('Error reading existing preferences:', error)
        return {}
      }
    })()

    localStorage.setItem(
      'userPreferences',
      JSON.stringify({
        ...existingPrefs, // Keep existing prefs
        ...prefs, // Override with new ones
      }),
    )
  },

  // Clear specific or all data
  clear: (key: any) => {
    if (typeof window === 'undefined') return
    if (key) {
      localStorage.removeItem(key)
    } else {
      localStorage.clear()
    }
  },
}
